import React from 'react';

interface QuestionNumberProps {
    questionIds: number[];
}

const questionidToDisplay = (questionid: number) => {
    if (questionid <= 50) {
        return `L${questionid}`;
    } else if (questionid <= 100) {
        return `R${questionid - 50}`;
    } else {
        return `5${questionid - 100}`;
    }
};


export const QuestionNumber: React.FC<QuestionNumberProps> = ({ questionIds }) => {
    if (questionIds.length === 0) return null;
    
    const displayText = questionIds.length > 1 
        ? `[${questionidToDisplay(questionIds[0])}~${questionidToDisplay(questionIds[questionIds.length - 1])}]`
        : `[${questionidToDisplay(questionIds[0])}]`;
    
    return <>{displayText}</>;
};